var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEscuroGrad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1080,
    height: 1228,
    viewBox: "0 0 1080 1228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M694.286 153.5C694.286 238.276 625.21 307 540 307C454.79 307 385.714 238.276 385.714 153.5C385.714 68.7243 454.79 0 540 0C625.21 0 694.286 68.7243 694.286 153.5Z",
    fill: "url(#paint0_radial_1002_1812)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M578.571 1189.63C578.571 1210.82 561.302 1228 540 1228C518.698 1228 501.429 1210.82 501.429 1189.63C501.429 1168.43 518.698 1151.25 540 1151.25C561.302 1151.25 578.571 1168.43 578.571 1189.63Z",
    fill: "url(#paint1_radial_1002_1812)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M554.921 655.345C590.385 662.26 617.143 693.351 617.143 730.66C617.143 757.684 603.105 781.446 581.888 795.121L490.797 876.189C506.25 881.358 522.796 884.16 540 884.16C625.21 884.16 694.286 815.436 694.286 730.66C694.286 674.298 663.753 625.031 618.247 598.337L554.921 655.345Z",
    fill: "url(#paint2_radial_1002_1812)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M587.944 584.716C572.853 579.812 556.738 577.16 540 577.16C454.79 577.16 385.714 645.884 385.714 730.66C385.714 787.477 416.742 837.084 462.858 863.625L526.587 806.254C490.376 799.938 462.857 768.497 462.857 730.66C462.857 703.185 477.368 679.082 499.181 665.523L587.944 584.716Z",
    fill: "url(#paint3_radial_1002_1812)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M559.443 961.833C592.635 970.408 617.143 1000.42 617.143 1036.13C617.143 1078.51 582.605 1112.88 540 1112.88C497.395 1112.88 462.857 1078.51 462.857 1036.13C462.857 1011.52 474.496 989.617 492.596 975.571L588.071 891.757C572.943 886.827 556.785 884.16 540 884.16C454.79 884.16 385.714 952.884 385.714 1037.66C385.714 1122.44 454.79 1191.16 540 1191.16C625.21 1191.16 694.286 1122.44 694.286 1037.66C694.286 982.284 664.812 933.757 620.621 906.759L559.443 961.833Z",
    fill: "url(#paint4_radial_1002_1812)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M308.571 460.5C308.571 545.276 239.495 614 154.286 614C69.0761 614 0 545.276 0 460.5C0 375.724 69.0761 307 154.286 307C239.495 307 308.571 375.724 308.571 460.5Z",
    fill: "url(#paint5_radial_1002_1812)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1080 460.5C1080 545.276 1010.92 614 925.714 614C840.505 614 771.429 545.276 771.429 460.5C771.429 375.724 840.505 307 925.714 307C1010.92 307 1080 375.724 1080 460.5Z",
    fill: "url(#paint6_radial_1002_1812)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M206.743 436.748L873.257 418.314V604.79C613.453 510.841 466.87 510.537 206.743 604.79V436.748Z",
    fill: "url(#paint7_radial_1002_1812)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M863.537 476.453H206.746V316.21C466.546 410.169 613.129 410.48 873.26 316.237L863.537 476.453Z",
    fill: "url(#paint8_radial_1002_1812)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M419.219 944.373C431.39 921.618 554.634 817.431 598.094 780.725C641.553 744.019 707.483 779.614 647.289 839.316C587.094 899.018 505.908 964.103 478.867 989.479C451.826 1014.86 407.047 967.128 419.219 944.373Z",
    fill: "url(#paint9_radial_1002_1812)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M426.228 625.924L594.876 474.102L647.522 531.989L478.286 683.843L426.228 625.924Z",
    fill: "url(#paint10_radial_1002_1812)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M661.123 1131.83C656.631 1143.73 569.789 1216.65 558.733 1223.06C547.677 1229.47 533.334 1182.4 533.334 1182.4L635.123 1103.26C635.123 1103.26 665.614 1119.94 661.123 1131.83Z",
    fill: "url(#paint11_radial_1002_1812)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M524.948 1224.29C510.362 1223.13 427.566 1145.55 420.671 1134.67C413.776 1123.78 475.095 1090.26 475.095 1090.26L564.101 1183.41C564.101 1183.41 539.533 1225.46 524.948 1224.29Z",
    fill: "url(#paint12_radial_1002_1812)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1002_1812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(548.571 652.984) rotate(90) scale(526.286 468.195)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1428A0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1002_1812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(548.571 652.984) rotate(90) scale(526.286 468.195)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1428A0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1002_1812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(548.571 652.984) rotate(90) scale(526.286 468.195)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1428A0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1002_1812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(548.571 652.984) rotate(90) scale(526.286 468.195)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1428A0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1002_1812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(548.571 652.984) rotate(90) scale(526.286 468.195)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1428A0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1002_1812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(548.571 652.984) rotate(90) scale(526.286 468.195)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1428A0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1002_1812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(548.571 652.984) rotate(90) scale(526.286 468.195)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1428A0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1002_1812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(548.571 652.984) rotate(90) scale(526.286 468.195)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1428A0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1002_1812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(548.571 652.984) rotate(90) scale(526.286 468.195)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1428A0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1002_1812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(548.571 652.984) rotate(90) scale(526.286 468.195)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1428A0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_1002_1812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(548.571 652.984) rotate(90) scale(526.286 468.195)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1428A0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_1002_1812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(548.571 652.984) rotate(90) scale(526.286 468.195)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1428A0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_1002_1812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(548.571 652.984) rotate(90) scale(526.286 468.195)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1428A0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEscuroGrad);
export default __webpack_public_path__ + "static/media/escuroGrad.9ab678205c79d7e980c02139a1112fc6.svg";
export { ForwardRef as ReactComponent };